import { ButtonCustom, ButtonStyle } from './styles'
interface ButtonProps extends ButtonStyle {
  text: string
  onClick?: any
  color?: string
  type?: any
  disabled?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  style?: React.CSSProperties;
}

export const Button = ({
  text,
  onClick,
  disabled,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  variantButton = 'default',
  backgroundColor = null,
  textColor = null,
  borderColor = null,
  type = 'button',
  width,
  hide = false,
  boxShadow,
  startIcon,
  endIcon,
  height
}: ButtonProps) => (
  <ButtonCustom
    id={`${text}-${type}-${variantButton}`}
    startIcon={startIcon}
    endIcon={endIcon}
    onClick={onClick}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    variantButton={variantButton}
    backgroundColor={backgroundColor}
    textColor={textColor}
    borderColor={borderColor}
    type={type}
    width={width}
    height={height}
    hide={hide}
    boxShadow={boxShadow}
    disabled={disabled}
  >
    {text}
  </ButtonCustom>
)
